import { EntityDefinition } from "ips/ac/model/types/EntityDefinition";

const ValueHelpDefinition: EntityDefinition = {
  ENTITY: "ValueHelp",
  ENTITY_SET: "ValueHelps",
};
export default ValueHelpDefinition;
